module.exports = __webpack_public_path__ + "static/media/workingmemory-words-6.d27ba284.mp3";